import React from 'react';
import { Routes as Switch, Route } from 'react-router-dom';
import Dashboard from '../pages/dashboard';
import Users from '../pages/user';
import Events from '../pages/events';
import Admin from '../pages/admin';
import Organizer from '../pages/organizer';
import MasterData from '../pages/masterData';
import Bookings from '../pages/bookings';
import Reports from '../pages/report';
import MainLayout from '../components/layout/mainlayout';
import SeatingArrangement from '../components/layout/seatingArrangement';
import SeatIndex from '../components/layout/seatIndex';
import RoundTableSeating from '../components/layout/roundTableSeating';
import Artists from '../pages/artists';
import AdminSeatGenerator from '../pages/AdminSeatGenerator';
import SeatAdminPanel from '../pages/SeatAdminPanel';
import SeatMapList from '../pages/SeatMapList';
import RoundTableEditor from '../pages/RoundTableEditor';
import AddEventFlow from '../pages/AddEventFlow';
import MediaLibrary from '../components/mediaManager/mediaLibrary';
import MediaUpload from '../components/mediaManager/mediaUpload'
import MediaLibraryManager from '../components/mediaManager/mediaLibraryManager';
import ForgotPassword from '../pages/forgotpassword';
import ForgotPasswordForm from '../components/auth/forgot-password-form';
import MyBookings from '../pages/myBookings';
import AdminBooking from '../components/events/adminBooking';
import RoleBasedRoute from '../components/RoleBasedRoute';


function ProtectedRoutes() {
  return (
    <Switch>
      {/* Dashboard - Admin only */}
      <Route 
        path="/dashboard" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Forgot password - public within protected routes */}
      <Route path="forgot-password" element={<ForgotPasswordForm />} />
      
      {/* Users - Admin only */}
      <Route 
        path="/users" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <Users />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Admin - Admin only */}
      <Route 
        path="/admin" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <Admin />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Organizer - Admin only */}
      <Route 
        path="/organizer" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <Organizer />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Events - Admin and Event Manager */}
      <Route 
        path="/events" 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <Events />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* All Bookings - Admin and Event Manager */}
      <Route 
        path="/bookings" 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <Bookings />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* My Bookings - Admin and Event Manager */}
      <Route 
        path='/my-bookings' 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <MyBookings />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Create Booking - Admin and Event Manager */}
      <Route 
        path='/admin-booking' 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <AdminBooking />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Seat Maps - Admin and Event Manager */}
      <Route 
       path="/seatmaps" 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <SeatMapList />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Seat Editor - Admin and Event Manager */}
      <Route 
        path="/seating-editor/:id?" 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <SeatAdminPanel />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Round Table Editor - Admin and Event Manager */}
      <Route 
        path="/round-table-editor/:id?" 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <RoundTableEditor />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Event Management - Admin and Event Manager */}
      <Route 
        path="/events/new" 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <AddEventFlow />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      <Route 
        path="/events/edit/:eventId" 
        element={
          <RoleBasedRoute allowedRoles={['admin', 'eventmanager']}>
            <MainLayout>
              <AddEventFlow />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Reports - Admin only */}
      <Route 
        path="/reports" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <Reports />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Artists - Admin only */}
      <Route 
        path="/artists" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <Artists/>
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Seating - Admin only */}
      <Route 
        path="/seating" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <SeatIndex />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Round Seating - Admin only */}
      <Route 
        path="/round-seating" 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <RoundTableSeating />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Master Data - Admin only */}
      <Route 
       path="admin/master-data"
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <MasterData />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
      
      {/* Media - Admin only */}
      <Route 
        path='/media' 
        element={
          <RoleBasedRoute allowedRoles={['admin']}>
            <MainLayout>
              <MediaLibraryManager />
            </MainLayout>
          </RoleBasedRoute>
        } 
      />
    </Switch>
  );
}

export default ProtectedRoutes;
